// v192 — Auto-quarantine settings API client (item 16 of
// docs/PRODUCT-ROADMAP.md, "Auto-Quarantine bei neuer CVE").
//
// Two endpoints under /api/v1/projects/{id}:
//   GET  /quarantine-settings    fetch project's settings
//   PUT  /quarantine-settings    upsert project's settings
//
// The shape mirrors the Go handler — the day-count is exposed
// directly so a numeric input renders without parsing PG INTERVAL
// strings.

import useSWR from 'swr';

export type QuarantineSeverity = 'low' | 'medium' | 'high' | 'critical';

export interface QuarantineSettings {
  enabled: boolean;
  severity_threshold: QuarantineSeverity;
  auto_block_until_days: number;
  notify_emails: string[];
  updated_at?: string;
  updated_by_email?: string;
}

const json = (url: string) =>
  fetch(url, { credentials: 'include' }).then((r) => {
    if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
    return r.json();
  });

export function useQuarantineSettings(projectId?: string) {
  return useSWR<QuarantineSettings>(
    projectId
      ? `/api/v1/projects/${encodeURIComponent(projectId)}/quarantine-settings`
      : null,
    json,
  );
}

export async function putQuarantineSettings(
  projectId: string,
  body: {
    enabled: boolean;
    severity_threshold: QuarantineSeverity;
    auto_block_until_days: number;
    notify_emails: string[];
  },
): Promise<void> {
  const res = await fetch(
    `/api/v1/projects/${encodeURIComponent(projectId)}/quarantine-settings`,
    {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
  if (!res.ok && res.status !== 204) {
    throw new Error(`${res.status}: ${await res.text()}`);
  }
}
